module.exports = __webpack_public_path__ + "static/img/weixin.cae2349a.png";